import styled, { css } from 'styled-components';
import { getTypographyStyles, SEM_TYPOGRAPHY_ACTION_XS_LABEL, SYS_BORDER_RADIUS_MAX, SYS_SIZE_FIXED_900, SYS_SPACE_FIXED_100, getMargins, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_1200, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_400, SEM_TYPOGRAPHY_ACTION_MD_LABEL, SEM_TYPOGRAPHY_ACTION_SM_LABEL } from '@oneaudi/unified-web-alpha-common';
import { ProgressIndicator } from '../progress-indicator/index.js';
import { Icon } from '../icon/index.js';
export const StyledIcon = styled(Icon) `
  // TODO: missing token
  flex-shrink: 0;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;
`;
export const StyledButton = styled.button `
  ${(props) => props.isLoading &&
    css `
      position: relative;
    `}
  margin: ${(props) => getMargins(props.margin)};
  border: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  border-radius: ${SYS_BORDER_RADIUS_MAX};

  ${(props) => {
    if (props.disabled && !props.isLoading) {
        return css `
        cursor: not-allowed;
      `;
    }
    if (props.isLoading) {
        return css `
        cursor: progress;
      `;
    }
    return css `
      cursor: pointer;
    `;
}}

  svg {
    flex-shrink: 0;
  }

  ${(props) => props.as === 'a'
    ? css `
          display: inline-flex;
          box-sizing: border-box;
          text-align: center;
        `
    : css `
          display: flex;
          border: 0;
        `}

  ${(props) => props.size === 'md'
    ? css `
          ${getTypographyStyles(SEM_TYPOGRAPHY_ACTION_MD_LABEL)}
          padding: ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_400};
          min-height: ${SYS_SIZE_FIXED_1400};
        `
    : props.size === 'sm'
        ? css `
            ${getTypographyStyles(SEM_TYPOGRAPHY_ACTION_SM_LABEL)}
            padding: ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_300};
            min-height: ${SYS_SIZE_FIXED_1200};
          `
        : css `
            ${getTypographyStyles(SEM_TYPOGRAPHY_ACTION_XS_LABEL)}
            padding: ${SYS_SPACE_FIXED_100} ${SYS_SPACE_FIXED_200};
            min-height: ${SYS_SIZE_FIXED_900};
          `}


  ${(props) => props.isFullWidth &&
    css `
      width: 100%;
    `}

    ${(props) => props.variant === 'primary' &&
    css `
      background: ${props.theme.sem.color.action.primary.surface.fill.default};
      color: ${props.theme.sem.color.action.primary.foreground.text.default};
      box-shadow: inset 0 0 0 1px
        ${props.theme.sem.color.action.primary.surface.stroke.default};
      transition-property: color, background, box-shadow;

      ${StyledIcon} {
        color: ${props.theme.sem.color.action.primary.foreground.icon.default};
      }

      ${!props.isLoading &&
        css `
        &:hover {
          background: ${props.theme.sem.color.action.primary.surface.fill
            .hover};
          color: ${props.theme.sem.color.action.primary.foreground.text.hover};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.primary.surface.stroke.hover};

          ${StyledIcon} {
            color: ${props.theme.sem.color.action.primary.foreground.icon
            .hover};
          }
        }

        &:active {
          background: ${props.theme.sem.color.action.primary.surface.fill
            .pressed};
          color: ${props.theme.sem.color.action.primary.foreground.text
            .pressed};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.primary.surface.stroke.pressed};

          ${StyledIcon} {
            color: ${props.theme.sem.color.action.primary.foreground.icon
            .pressed};
          }
        }
      `}

      ${props.as === 'button' &&
        !props.isLoading &&
        css `
        &:disabled {
          background: ${props.theme.sem.color.action.primary.surface.fill
            .disabled};
          color: ${props.theme.sem.color.action.primary.foreground.text
            .disabled};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.primary.surface.stroke.disabled};

          ${StyledIcon} {
            color: ${props.theme.sem.color.action.primary.foreground.icon
            .disabled};
          }
        }
      `}
    `}
    
  ${(props) => props.variant === 'secondary' &&
    css `
      background-color: ${props.theme.sem.color.action.secondary.surface.fill
        .default};
      color: ${props.theme.sem.color.action.secondary.foreground.text.default};
      box-shadow: inset 0 0 0 1px
        ${props.theme.sem.color.action.secondary.surface.stroke.default};
      transition-property: color, box-shadow, background-color;

      ${StyledIcon} {
        color: ${props.theme.sem.color.action.secondary.foreground.icon
        .default};
      }

      ${!props.isLoading &&
        css `
        &:hover {
          background-color: ${props.theme.sem.color.action.secondary.surface
            .fill.hover};
          color: ${props.theme.sem.color.action.secondary.foreground.text
            .hover};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.secondary.surface.stroke.hover};

          ${StyledIcon} {
            color: ${props.theme.sem.color.action.secondary.foreground.icon
            .hover};
          }
        }

        &:active {
          background-color: ${props.theme.sem.color.action.secondary.surface
            .fill.pressed};
          color: ${props.theme.sem.color.action.secondary.foreground.text
            .pressed};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.secondary.surface.stroke.pressed};

          ${StyledIcon} {
            color: ${props.theme.sem.color.action.secondary.foreground.icon
            .pressed};
          }
        }
      `}

      ${props.as === 'button' &&
        !props.isLoading &&
        css `
        &:disabled {
          background-color: ${props.theme.sem.color.action.secondary.surface
            .fill.disabled};
          color: ${props.theme.sem.color.action.secondary.foreground.text
            .disabled};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.secondary.surface.stroke.disabled};

          ${StyledIcon} {
            color: ${props.theme.sem.color.action.secondary.foreground.icon
            .disabled};
          }
        }
      `}
    `}

  ${(props) => props.variant === 'tertiary' &&
    css `
      background-color: ${props.theme.sem.color.action.tertiary.surface.fill
        .default};
      color: ${props.theme.sem.color.action.tertiary.foreground.text.default};
      box-shadow: inset 0 0 0 1px
        ${props.theme.sem.color.action.tertiary.surface.stroke.default};
      transition-property: color, box-shadow, background-color;

      ${StyledIcon} {
        color: ${props.theme.sem.color.action.tertiary.foreground.icon.default};
      }

      ${!props.isLoading &&
        css `
        &:hover {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
            .hover};
          color: ${props.theme.sem.color.action.tertiary.foreground.text.hover};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.tertiary.surface.stroke.hover};

          ${StyledIcon} {
            color: ${props.theme.sem.color.action.tertiary.foreground.icon
            .hover};
          }
        }

        &:active {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
            .pressed};
          color: ${props.theme.sem.color.action.tertiary.foreground.text
            .pressed};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.tertiary.surface.stroke.pressed};

          ${StyledIcon} {
            color: ${props.theme.sem.color.action.tertiary.foreground.icon
            .pressed};
          }
        }
      `}

      ${props.as === 'button' &&
        !props.isLoading &&
        css `
        &:disabled {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
            .disabled};
          color: ${props.theme.sem.color.action.tertiary.foreground.text
            .disabled};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.tertiary.surface.stroke.disabled};

          ${StyledIcon} {
            color: ${props.theme.sem.color.action.tertiary.foreground.icon
            .disabled};
          }
        }
      `}
    `}
`;
export const StyledButtonContent = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.size === 'xs' ? SYS_SPACE_FIXED_100 : SYS_SPACE_FIXED_150};

  ${(props) => props.isLoading &&
    css `
      opacity: 0;
      visibility: hidden;
      height: 0;
      pointer-events: none;
    `}
`;
export const StyledProgressIndicator = styled(ProgressIndicator) `
  position: absolute;
`;
//# sourceMappingURL=index.styles.js.map